import { render, staticRenderFns } from "./vehicleRepairApplyDetail.vue?vue&type=template&id=0f4f9165&scoped=true"
import script from "./vehicleRepairApplyDetail.vue?vue&type=script&lang=js"
export * from "./vehicleRepairApplyDetail.vue?vue&type=script&lang=js"
import style0 from "./vehicleRepairApplyDetail.vue?vue&type=style&index=0&id=0f4f9165&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4f9165",
  null
  
)

export default component.exports